import Selector from './selector.vue'

Selector.install = function (Vue) {
	Vue.component(Selector.name, Selector);
}

export default Selector;